import React from "react";
import {
  FeaturedPostsBase,
  LargePostContainer,
  RecentStories,
  LargePostAndRecentStories,
  RecentStoriesTitle,
  RecentStory,
  RecentStoriesSection,
  RecentStoriesContent,
  RecentStoryLink,
  SmallPostCards,
  SmallPostCardContainer,
} from "./featured-posts.styled";
import {
  FeaturedPostsFragment,
  ContentHubPageQuery,
} from "../../types/graphql";
import SmallPostCard from "../small-post-card/small-post-card";
import LargePostCard from "../large-post-card/large-post-card";
import { linkTo } from "../../utils/contentUtils";

interface IFeaturedPostsProps {
  featuredPosts?: FeaturedPostsFragment | null;
  recentPosts: ContentHubPageQuery["allPrismicContentPost"];
}

const FeaturedPosts = (props: IFeaturedPostsProps) => {
  const largeFeaturedPost = props.featuredPosts?.data?.large_featured_post;
  const recentPosts = props.recentPosts.nodes;
  const smallFeaturedPosts =
    props.featuredPosts?.data?.small_featured_posts?.slice(0, 3);

  return (
    <FeaturedPostsBase>
      <LargePostAndRecentStories>
        {largeFeaturedPost?.document && "type" in largeFeaturedPost.document && (
          <LargePostContainer>
            <LargePostCard largePostCard={largeFeaturedPost.document} />
          </LargePostContainer>
        )}
        {recentPosts && (
          <RecentStoriesSection>
            <RecentStoriesContent>
              <RecentStoriesTitle>RECENT STORIES</RecentStoriesTitle>
              <RecentStories>
                {recentPosts.map((recentPostEdge, index) => {
                  const recentPost = recentPostEdge?.data;
                  return (
                    recentPost &&
                    recentPost.title && (
                      <RecentStory key={index}>
                        <RecentStoryLink href={linkTo(recentPostEdge)}>
                          {recentPost.title}
                        </RecentStoryLink>
                      </RecentStory>
                    )
                  );
                })}
              </RecentStories>
            </RecentStoriesContent>
          </RecentStoriesSection>
        )}
      </LargePostAndRecentStories>
      {smallFeaturedPosts && (
        <SmallPostCards>
          {smallFeaturedPosts.map((smallFeaturedPost, index) => {
            const post = smallFeaturedPost?.post;
            return (
              post?.document &&
              "type" in post.document && (
                <SmallPostCardContainer key={index}>
                  <SmallPostCard post={post.document} />
                </SmallPostCardContainer>
              )
            );
          })}
        </SmallPostCards>
      )}
    </FeaturedPostsBase>
  );
};

export default FeaturedPosts;
